import type { ReactNode } from 'react';

export type DataPanelGroupProps = {
  cssClass?: string;
  children?: ReactNode;
};

export function DataPanelGroup({ cssClass, children }: DataPanelGroupProps) {
  return (
    <div className={`data-panel ${cssClass ?? ''}`}>
      <div className="data-panel__content d-flex flex-column" style={{ rowGap: '1px' }}>
        {children}
      </div>
    </div>
  );
}
